// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEnquiry_root__2gmc7","marketplaceColorStroke":"IconEnquiry_marketplaceColorStroke__1-jzg"};